export default [
    'an',
    'auf',
    'hinter',
    'in',
    'neben',
    'über',
    'unter',
    'vor',
    'zwischen'
];


/** WEBPACK FOOTER **
 ** ./app/components/pages/exercisePages/Prepositions/twoWayPrepositions.js
 **/